import styled, { css } from 'styled-components';
import {
  backgroundShape,
  getGridSpans,
  px2rem,
  getColor,
  getSpace,
  mq
} from '../../../stylesheets/tools';

const handleColorType = color => {
  switch (color) {
    case 'blue':
      return getColor('mfDarkBlue');
    case 'grey':
      return getColor('mfDarkGrey');
    case 'green':
      return getColor('mfDarkGreen');
    default:
      return '#000';
  }
};

const StyledTypoHeadline = styled.div`
  ${getGridSpans('width', { s: 10, m: 5 })}

  ${props =>
    props.alignment === 'right'
      ? getGridSpans('margin-left', { m: 6 })
      : `${mq('m')} {margin-left: ${getSpace('l')}}`};

  ${props => (props.alignment === 'center' ? getGridSpans('margin-left', { m: 3 }) : '')}

  .typoHeadline__headline {
    width: calc(100% - 2px);
    position: relative;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    [data-whatinput='mouse'] &,
    [data-whatinput='touch'] & {
      outline: 0;
    }
  }

  .typoHeadline__first-line {
    width: 100%;
    white-space: normal;
  }

  .typoHeadline__first-word {
    min-width: ${px2rem('170px')};
    display: inline-block;
    padding: 5px 10px;
    text-align: center;
    color: #fff;

    ${props =>
      !props.highlight &&
      css`
        border: 2px solid
          ${props.color === 'default'
            ? props.theme.siteTheme.borderColor
            : handleColorType(props.color)};

        color: ${props.color === 'default'
          ? props.theme.siteTheme.borderColor
          : handleColorType(props.color)};
      `}

    ${props =>
      props.highlight &&
      css`
        ${props.color === 'default'
          ? backgroundShape(props.theme.siteTheme.borderColor)
          : backgroundShape(handleColorType(props.color))}
      `}
  }

  .typoHeadline__word {
    margin-top: -2px;
    margin-right: -2px;
    display: inline-block;
    background-color: #fff;
    padding: 5px 10px;
    border: 2px solid #000;
    color: #000;
    text-align: center;

    ${props =>
      props.theme.siteTheme &&
      css`
        border-color: ${props.theme.siteTheme.borderColor};
        color: ${props.theme.siteTheme.borderColor};
      `}

    ${props =>
      props.color !== 'default' &&
      css`
        border-color: ${handleColorType(props.color)};
        color: ${handleColorType(props.color)};
      `}
  }
`;

export default StyledTypoHeadline;
